 <template>
 <div v-role="'func'" style="margin:auto;width:1600px;margin-top:10px;">
     <v-progress-linear  style="margin : 0 auto ; height:10px" :indeterminate="isLoading" v-show="isLoading"></v-progress-linear>
 <div>
  <v-data-table
    :headers="headers"
    :items="pagamentos"
    :search="searchInDb"
    :sort-desc="true"

    class="elevation-1"
   >
    <template v-slot:top>
      <v-toolbar flat color="white">

        <v-toolbar-title class="hidden-sm-and-down">
          Pagamento de emolumento
        </v-toolbar-title>

        <v-divider class="mx-8  hidden-sm-and-down" inset vertical></v-divider>
         <div class="flex-grow-1"></div>
         <v-row>
        <v-col v-if="!$store.state.hasMessage" class="text-center" cols="4" ><v-btn style="margin-top:15px;" x-large fab dark color="primary" @click="dialog=true">
              <v-icon dark>add</v-icon>
            </v-btn></v-col>
      </v-row>
        <!--  search  -->
        <div v-if="$store.state.hasMessage" :class="$store.state.classMessage">
          {{ $store.state.textMessage }}
        </div>

        <div class="flex-grow-1"></div>
<v-btn  v-if="searchInDb"  @click="loadPagamentos(searchInDb)" text icon color="green">
              <v-icon>cached</v-icon>
            </v-btn>
          <v-text-field
              v-model="searchInDb"
              append-icon="search"
              label="Pesquisa"

              single-line
              hide-details
          ></v-text-field>
        <v-spacer></v-spacer>
        <v-dialog v-model="dialog" max-width="700px" persistent>

          <v-card>
            <v-overlay :value="overlay">
            <v-progress-circular
              indeterminate
              size="64"
            ></v-progress-circular>
          </v-overlay>
            <v-card-title>
              <span class="headline">Definir tempo bloqueio</span>
               <v-progress-circular
                    v-if="progresso"
                    color="green"
                    indeterminate
                  ></v-progress-circular>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-form ref="form" v-model="formValid" lazy-validation>
                  <v-row>
                    <v-col cols="12" sm="12" md="12">
                      <div
                        v-if="$store.state.hasMessage"
                        :class="$store.state.classMessage"
                      >
                        {{ $store.state.textMessage }}
                      </div>

                    </v-col>
                    <v-col cols="12" sm="12" md="12">
              <v-combobox
                v-model="editedItem.instituicao"
                :rules="obrigqtorioRules"
                item-value="idInstituicao"
                item-text="descricao"
                :items="instituicoes"
                filled
                outlined
                color="blue-grey lighten-2"
                label="Instituicao"
              ></v-combobox>
           </v-col>
           <v-col cols="6" sm="6" md="6">
              <v-combobox
                v-model="editedItem.emolumento"
                :rules="obrigqtorioRules"
                item-value="pkemolumentos"
                item-text="descricao"
                :items="emolumentos"
                filled
                outlined
                color="blue-grey lighten-2"
                label="Emolumentos"
              ></v-combobox>
           </v-col>
           <!-- <v-col cols="7" sm="7" md="7">
            <v-text-field
                    outlined
                      v-model="editedItem.pagamento"
                      :rules="ruleTextRequiredPagamento"
                      label="Pagamento"
                      prepend-icon="money"
                    ></v-text-field>
           </v-col> -->
           <v-col cols="6" sm="6" md="6">
              <v-combobox
                v-model="editedItem.databloqueio"
                :rules="[v => !!v || 'Campo obrigatorio!']"
                item-value="descricao"
                item-text="novadescricao"
                :items="anoslectivo"
                filled
                outlined
                color="blue-grey lighten-2"
                label="Selecione o ano lectivo"
              ></v-combobox>
           </v-col>
                  </v-row>
                </v-form>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red darken-1" text @click="close">Cancelar</v-btn>
              <v-btn
                color="green darken-1"
                :disabled="
                  !(formValid)
                "
                text
                @click="Guardar()"
                >Salvar</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    

      <template v-slot:item.estado="{ item }">
      <span :style="(item.estado)?'color:green;font-weight:bold':'color:red;font-weight:bold;'">{{(item.estado)?'Emolumento disponível':'Emolumento Bloqueado'}}</span>
     </template>
     
    <template v-slot:item.action="{ item }">
      <v-icon v-if="(item.estado)" color="green darken-3" size="20" @click="actualizarStatus(item,0)">cached</v-icon>
      <v-icon v-if="(!item.estado)" color="red darken-3" size="20" @click="actualizarStatus(item,1)">cached</v-icon>
     </template>
    <template v-slot:no-data>
      no data
    </template>
  </v-data-table>
 </div>
 </div>
</template>
<script>
import axios from '../../../plugins/axios'
import Swal from 'sweetalert2'
const ls = require('local-storage')
// const message = require('../config/messages')
export default {
  data: () => ({
    pagamentos: [],
    anoslectivo: [],
    obrigqtorioRules: [value => !!value || 'campo obrigatorio'],
    ruleTextRequiredPagamento: [
      value => !!value || 'campo obrigatório.',
      value => {
        const pattern = /(([.,0-9]))$/
        return !!pattern.test(value) || 'Invalido.'
      }
    ],
    progresso: false,
    formValid: true,
    menu: false,
    searchInDb: '',
    date_: null,
    overlay: false,
    valid: true,
    sucess: false,
    dialog: false,
    err: false,
    isLoading: false,
    instituicoes: [],
    emolumentos: [],
    headers: [
      {text:'Instituição', value:'descricao'},
      {text:'Emolumento', value:'tipo_emolumento'},
      {text:'Ano lectivo', value:'dataDisponivel'},
      {text:'Status', value:'estado'},
      {text:'Acção', value:'action'},
    ],
    editedItem: {
      descricao: '',
      instituicao: null,
      isintegrado: 0,
       dataDisponivel: '', 
       estado: 0, 
       fkEmolumento: 0, 
       emolumento: '',
       databloqueio: null,
       pagamento: null

    },
    defaultItem: {
      descricao: '',
      instituicao: null,
      isintegrado: 0,
       dataDisponivel: '', 
       estado: 0, 
       fkEmolumento: 0, 
       emolumento: '',
       databloqueio: null,
       pagamento: null
    }
  }),

  watch: {
  },

  computed: {

    instituicaodescricao () {
      return ls.get('instituicaodescricao')
    },
    anolectivo () {
      return ls.get('anolectivo')
    },
    loggedUserName () {
      return ls.get('nomeUsuario')
    },
    role () {
      let rl = ''
      if (ls.get('role') === 'ROLE_ADM') {
        rl = 'logado como Administrador'
      } else if (ls.get('role') === 'ROLE_PROF') {
        rl = 'logado como Professor'
      } else if (ls.get('role') === 'ROLE_FUNC') {
        rl = 'logado como Funcionario'
      } else if (ls.get('role') === 'ROLE_EST') {
        rl = 'logado como Estudante'
      } else if (ls.get('role') === 'ROLE_DIR') {
        rl = 'logado como Director'
      } else if (ls.get('role') === 'ROLE_COOR') {
        rl = 'logado como Coordenador de Curso'
      } else if (ls.get('role') === 'ROLE_PED') {
        rl = 'logado como Coordenador de Curso'
      } else if (ls.get('role') === 'ROLE_PWR') {
        rl = 'logado como Usuário com Superiores Previlgêgios'
      } else if (ls.get('role') === 'ROLE_DIRCOL') {
        rl = 'logado como Director de Colégio'
      }
      return rl
    }

  },

  loggedUserName () {
    return ls.get('idPessoa')
  },
  created () {
    this.loadAnolectivo()
     this.loadPagamentos()
     this.initializeInstituicoes()
     this.initializeEmolumentos()
   },

  methods: {

    close () {
      this.editedItem = this.defaultItem
      this.dialog = false
    },

    async loadPagamentos () {
      this.isLoading = true
      try {
        this.pagamentos = await axios.get('/getPagamentosEmolumentos').then(res => res.data)
        this.isLoading = false
      } catch (error) {
        this.isLoading = false
        Swal.fire('Informação', 'Ocorreu um erro', 'error')
      }
    },

async actualizarStatus(item,status_){
      this.overlay = true
      let params = {
        instituicao: {descricao: item.descricao,idInstituicao:item.idinstituicao},
        emolumento: {pkemolumentos: item.fkEmolumento,descricao: item.tipo_emolumento},
        pagamento: item.pagamento,
        anolectivo: item.anoLectivo,
        autor: ls.get('idPessoa'),
        status_: status_
      }
      try {
        let result = await axios.post('/definirTempoBloqueioEmolumento', params).then((res)=>res.data)
        if( result.affectedRows >= 1 ){
          this.overlay = false
          this.close()
          Swal.fire('Informação', 'Alteração feita com sucesso.', 'success')
          this.loadPagamentos()
        }      
      } catch (error) {
        this.overlay = false
        Swal.fire('Informação', 'Ocorreu um erro', 'error')
      }
    
},

  async  Guardar () {

    if (this.$refs.form.validate()) {
      this.overlay = true
      let params = {
        instituicao: this.editedItem.instituicao,
        emolumento: this.editedItem.emolumento,
        pagamento: this.editedItem.pagamento,
        anolectivo: this.editedItem.databloqueio.descricao,
        autor: ls.get('idPessoa'),
        status_: 1
      }
      try {
        let result = await axios.post('/definirTempoBloqueioEmolumento', params).then((res)=>res.data)
        if( result.affectedRows >= 1 ){
          this.overlay = false
          this.close()
          Swal.fire('Informação', 'Definição de tempo de abertura feita com sucesso.', 'success')
          this.loadPagamentos()
        }      
      } catch (error) {
        this.overlay = false
        Swal.fire('Informação', 'Ocorreu um erro', 'error')
      }
    }

  },

    async initializeInstituicoes () {
      this.isLoading = true
      try {
        this.instituicoes = await axios.get('/listarInstituicao').then((res)=>res.data)
         this.isLoading = false
      } catch (error) {
        this.isLoading = false
        Swal.fire('Informação', 'Ocorreu um erro', 'error')
      }
    },
    async initializeEmolumentos () {
      this.isLoading = true
      try {
        this.emolumentos = await axios.get('/getEmolumentos').then(res => res.data)
        this.isLoading = false
      } catch (error) {
        this.isLoading = false
        Swal.fire('Informação', 'Ocorreu um erro', 'error')
      }
    },
    async loadAnolectivo () {
      try {
        this.anoslectivo = await axios
          .get('/listarAnoLectivoAll')
          .then(res => res.data)
      } catch (error) {
        Swal.fire('Informação', 'Ocorreu um erro', 'error')
      }
    },
   
  }
}

</script>
